/// <reference types="node" />
import { createClient } from "@sanity/client";

export const client = createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID, // or NEXT_PUBLIC_SANITY_PROJECT_ID
  dataset: process.env.REACT_APP_SANITY_DATASET,     // or NEXT_PUBLIC_SANITY_DATASET
  apiVersion: "2024-01-01",
  useCdn: false,
});